export default __webpack_public_path__ + "static/media/roadmap_image.fafe6717.png";